const cintos = [

  // INZER
  {
    id: "inzer-forever-13",
    slug: "cinto-inzer-forever-13",
    name: "Inzer Forever Lever Belt 13mm",
    brand: "INZER",
    sizeGuide: "/Guias/sg-cinto-inzer.png",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    category: "cinturones",
    variants: [{image:"/Productos/cinto-inzer.png", price:261, oldPrice: 290
    }
    ]
  },
  {
    id: "inzer-forever-10",
    slug: "cinto-inzer-forever-10",
    category: "cinturones",
    name: "Inzer Forever Lever Belt 10mm",
    brand: "INZER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [{image:"/Productos/cinto-inzer.png", price:252, oldPrice:280
    }
    ]
  },
  // SBD 10mm
  {
    id: "sbd-10mm",
    slug: "cinto-sbd-10mm",
    name: "SBD Belt 10mm",
    category: "cinturones",
    sizeGuide: "/Guias/sg-cinto-sbd.png",
    brand: "SBD",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { color: "Classic", images: ["/Productos/cinto-sbd-10mm.webp","/Productos/cinto-sbd-10-2.webp",], price: 485 },
      { color: "Resolve", images: ["/Productos/cinto-sbd-res-10.webp","/Productos/cinto-sbd-res-10-2.webp","/Productos/cinto-sbd-res-10-3.webp",], price: 485 },
    ],
  },

  // SBD 13mm
  {
    id: "sbd-13mm",
    slug: "cinto-sbd-13mm",
    name: "SBD Belt 13mm",
    category: "cinturones",
    sizeGuide: "/Guias/sg-cinto-sbd.png",
    brand: "SBD",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { color: "Classic", images: ["/Productos/cinto-sbd.webp","/Productos/cinto-sbd-13-2.webp","/Productos/cinto-sbd-13-3.webp"], price: 485 },
      { color: "Resolve", images: ["/Productos/sbd-belt-res-13.jpg","/Productos/cinto-sbd-res-13-2.webp","/Productos/cinto-sbd-res-13-3.jpg",], price: 485 },
    ],
  },

  // PIONEER (convertidos a modelo con variants)
  {
    id: "pioneer-double-suede-lever-10",
    slug: "cinto-pioneer-palanva-doble-gamuza-10mm",
    name: "Pioneer Palanca Doble Gamuza 10mm",
    category: "cinturones",
    brand: "PIONEER",
    sizeGuide: "/Guias/sg-cinto-pioneer.png",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { images: ["/Productos/cinto-pio-ds-10.webp","/Productos/cinto-pio-ds-10-2.webp",], price: 275 }
    ],
  },
  {
    id: "pioneer-powder-coat-v2-13",
    slug: "cinto-pioneer-palanca-pal-v2-logo-13mm",
    name: "Pioneer 13mm Palanca PAL V2 con Logo",
    category: "cinturones",
    brand: "PIONEER",
    sizeGuide: "/Guias/sg-cinto-pioneer.png",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { images: ["/Productos/cinto-pio-pal-13.webp","/Productos/cinto-pio-pal-13-2.webp",], price: 305 }
    ],
  },
  {
    id: "pioneer-embroidered-logo-13",
    category: "cinturones",
    slug: "cinto-pioneer-doble-gamuza-pal-v2-logo-bordado-13mm",
    name: "Pioneer 13mm Doble Gamuza PAL V2 Logo Bordado",
    sizeGuide: "/Guias/sg-cinto-pioneer.png",
    brand: "PIONEER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { images: ["/Productos/cinto-pio-embr-logo.webp","/Productos/cinto-pio-embr-logo-2.webp",], price: 330 }
    ],
  },
  {
    id: "pioneer-prong-13",
    category: "cinturones",
    slug: "cinto-pioneer-hebilla-13mm",
    name: "Pioneer Hebilla 13mm",
    sizeGuide: "/Guias/sg-cinto-pioneer.png",
    brand: "PIONEER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { images: ["/Productos/cinto-pio-heb-13.jpg","/Productos/cinto-pio-heb-13-2.webp"], price: 270 }
    ],
  },
  {
    id: "pioneer-double-suede-prong-10",
    category: "cinturones",
    slug: "cinto-pioneer-doble-gamuza-hebilla-10mm",
    name: "Pioneer Doble Gamuza Hebilla 10mm",
    sizeGuide: "/Guias/sg-cinto-pioneer.png",
    brand: "PIONEER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { images: ["/Productos/cinto-pio-heb-10.webp","/Productos/cinto-pio-heb-10-2.webp",], price: 260 }
    ],
  },

  // A7
  {
    id: "a7-lever-1013",
    category: "cinturones",
    slug: "cinto-a7-palanca",
    name: "A7 Palanca",
    brand: "A7",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    variants: [
      { thickness: "10mm", image: "/Productos/cinto-a7-palanca.webp", price: 390 },
      { thickness: "13mm", image: "/Productos/cinto-a7-palanca.webp", price: 390 },
    ],
  },
  {
    id: "a7-prong-1013",
    category: "cinturones",
    slug: "cinto-a7-pioneer-cut-prong",
    name: "A7 Pioneer Cut Prong Belt",
    brand: "A7",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    variants: [
      { thickness: "10mm", image: "/Productos/cinto-a7-hebilla.webp", price: 370 },
      { thickness: "13mm", image: "/Productos/cinto-a7-hebilla.webp", price: 370 },
    ],
  },

  // STRENGTHSHOP
  {
    id: "strengthshop-lever",
    slug: "cinto-strengthshop-palanca",
    name: "Strengthshop Palanca",
    brand: "STRENGHTSHOP",
    category: "cinturones",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    variants: [
      { thickness: "10mm", image: "/Productos/cinto-st-sh-10mm.webp", price: 220 },
      { thickness: "13mm", image: "/Productos/cinto-st-sh-10mm.webp", price: 230 },
    ],
  },

  // STOIC
  {
    id: "stoic-lever-13",
    category: "cinturones",
    slug: "cinto-stoic-palanca-13mm",
    name: "Stoic Palanca 13mm",
    brand: "STOIC",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { image: "/Productos/cinto-stoic.webp", price: 245 }
    ],
  },

];

export default cintos;
